import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ThemePalette } from '@angular/material/core';
import { ClientesService } from 'src/app/service/clientes.service';
import { Router } from '@angular/router';
import { AccountService } from './../service/account.service';
import { VerificarPermissoes } from './../model/verificarPermissoes.model';
import { GruposService } from './../service/grupos.service';
import { Grupos } from './../model/grupos.model';
import { Component, OnInit } from '@angular/core';
import { Cliente } from '../model/cliente.model';
import { BuscaService } from './../service/busca.service';
import { ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-grupos',
  templateUrl: './grupos.component.html',
  styleUrls: ['./grupos.component.css']
})
export class GruposComponent implements OnInit {

  grupos: Grupos[] = [];
  public clienteId!: string;
  clientes!: Cliente[];
  load = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  public columnsToDisplay = [
    'vc_nome',
    'bl_status',
    'acaoEditar',
    'acaoExluir'
  ];
  public dataSource: MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  constructor(private service: GruposService,
    private accountService: AccountService,
    private serviceCliente: ClientesService,
    private router: Router,
    private buscaService: BuscaService,
  ) { }

  ngOnInit(): void {
    this.filtroDataSource();
    this.listarCliente();
  }

  listarGrupoPaginate(): void {
    this.dataSource.data = [];
    this.load = true;
    this.service.listarServiceGrupos(this.clienteId).subscribe(
      (resp: any) => {
        this.load = false
        this.grupos = resp;
        this.dataSource.data = this.grupos;
        this.dataSource.paginator = this.paginator;
      }, error => {
        if (error == "401") {
          localStorage.removeItem('token')
          this.router.navigate(['/'])
        }

      }
    )
  }

  listarCliente(): void {
    this.serviceCliente.listarServiceClientes().subscribe((resp: any) => {
      this.clientes = resp
      this.clienteId = localStorage.getItem('cliente')!;
      this.listarGrupoPaginate();
    },
      error => {
        if (error == "401") {
          localStorage.removeItem('token')
          this.router.navigate(['/'])
        }

      })
  }

  finalizar(grupo: Grupos): void {
    if (grupo.bl_status) {
      this.service.confirmAlert(grupo);
    } else {
      this.service.desativarAlert(grupo);
    }
  }


  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

  filtraGrupos(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  filtroDataSource(): void {
    this.dataSource.filterPredicate = (data: Cliente, filter: string) => {
      let nomeFiltro = this.buscaService.removerAcentos(data.vc_nome).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase()));
      return nomeFiltro
    }
  }

  grupoInativo(grupo: Grupos): boolean {
    return grupo.bl_status == 0;
  }
}
